import uniqueId from '@form-create/utils/lib/unique';
import { makeRequiredRule } from '../../utils';
var label = '多行文本';
var name = 'input';
export default {
  icon: 'iconfont iconduohangwenben1',
  label: label,
  name: 'textarea',
  rule: function rule() {
    return {
      type: name,
      field: uniqueId(),
      title: label,
      info: '',
      props: {
        type: 'textarea'
      }
    };
  },
  props: function props() {
    return [makeRequiredRule()];
  },
  basic: function basic() {}
};